import { render, staticRenderFns } from "./ScrollPane.vue?vue&type=template&id=fd5adf20"
import script from "./ScrollPane.vue?vue&type=script&lang=js"
export * from "./ScrollPane.vue?vue&type=script&lang=js"
import style0 from "./ScrollPane.vue?vue&type=style&index=0&id=fd5adf20&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports